import { Modal } from "react-bootstrap"

export const AiConformationModal = ({
    showAiConfirmationModal,
    setShowAiConfirmationModal,
    setIsResponseGenerated,
    type
}) => {
    return (
        <Modal
            show={showAiConfirmationModal}
            onHide={() => setShowAiConfirmationModal(false)}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{type}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Would you like to {type} a response?</p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-outline-primary btn-blue"
                    onClick={() => setShowAiConfirmationModal(false)}>
                    Cancel
                </button>
                <button
                    className="btn btn-primary btn-blue"
                    // onClick={handleSave}
                    onClick={() => {
                        setIsResponseGenerated(true);
                        setShowAiConfirmationModal(false)
                    }}
                >{type}</button>
            </Modal.Footer>
        </Modal>
    )
}